import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Update = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Update" {...props}>
    <path d="M20.8203 13.8008C20.9303 13.2597 21.4579 12.9097 21.999 13.0195C22.5403 13.1294 22.8901 13.658 22.7803 14.1992C21.761 19.2205 17.3228 23.0009 12 23.001C8.27737 23.001 4.99001 21.15 3 18.3223V21C2.99997 21.5523 2.55226 22 2 22C1.44774 22 1.00003 21.5523 1 21V16C1 15.4477 1.44772 15 2 15H7C7.55228 15 8 15.4477 8 16C7.99997 16.5523 7.55226 17 7 17H4.5166C6.13191 19.4126 8.88101 21.001 12 21.001C16.3529 21.0009 19.9865 17.9085 20.8203 13.8008Z" fill="#000" /><path d="M12 1C15.7217 1.00008 19.0096 2.84864 21 5.67578V3C21 2.44772 21.4477 2 22 2C22.5523 2 23 2.44772 23 3V8C23 8.55226 22.5523 9 22 9H17C16.4477 9 16 8.55226 16 8C16 7.44772 16.4477 7 17 7H19.4844C17.869 4.58719 15.1191 3.00009 12 3C7.64709 3 4.01363 6.09164 3.17969 10.1992C3.06971 10.7401 2.54196 11.09 2.00098 10.9805C1.45975 10.8706 1.10988 10.342 1.21973 9.80078C2.23928 4.77966 6.67729 1 12 1Z" fill="#000" />
  </StyledIcon>
));

Update.displayName = 'Update';

export { Update };
